import { confirmOrderAction } from "./confirmOrderAction";

export const confirmDelivery = (
  accessCode: string,
  accessToken: string,
  orderId: string
) => confirmOrderAction(accessCode, accessToken, orderId, "confirmDelivery");
